export default function ScreenProtection({ children }) {
  return <>{children}</>;
}
